import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

const getInvoicesDateRequest = (token, startDate, endDate) => {
  const organizationId = localStorage.getItem("organizationId");

  let url =
    apiURl +
    "invoice?organizationId=" +
    organizationId +
    `&startDate=${startDate}` +
    `&endDate=${endDate}`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const uploadInvoiceRequest = (token, fileData) => {
  const organizationId = localStorage.getItem("organizationId");
  const url = apiURl + "invoice/upload?organizationId=" + organizationId;
  const parameters = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      // НЕ слагай Content-Type, fetch ще го сложи автоматично за FormData!
    },
    body: fileData,
  };
  return fetchAndReturn(url, parameters);
};

export { getInvoicesDateRequest, uploadInvoiceRequest };
